import { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { IRegistration } from '../../NewRegistrationContext';
import { applicationContext } from 'helpers/services';


interface IProps {
    registration: IRegistration
}

let Summary = ({ registration }: IProps) => {
    let appService = useContext(applicationContext);


    return (
        <>
            <Grid container>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.userFirstname}&nbsp;{registration.userLastname}</Typography>
                    <Typography gutterBottom>Name</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">
                        {appService.countries.getValueByKey(registration.userCountryCode)}
                    </Typography>
                    <Typography gutterBottom>Country</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.username}</Typography>
                    <Typography gutterBottom>Email</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.sku}</Typography>
                    <Typography gutterBottom>SKU</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.productBrand}</Typography>
                    <Typography gutterBottom>Brand</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.shortDescription}</Typography>
                    <Typography gutterBottom>Short Description</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <Typography variant="h4">
                        <Moment date={registration.purchaseDate} format="L" />
                    </Typography>
                    <Typography gutterBottom>Purchase Date</Typography>
                </Grid>
                <Grid item xs>
                    <Typography variant="h4">{registration.serialNumber || '-'}</Typography>
                    <Typography gutterBottom>Serial Number</Typography>
                </Grid>
                <Grid item xs>
                    <Typography variant="h4">{registration.qrCode || '-'}</Typography>
                    <Typography gutterBottom>QrCode</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.dealerName}</Typography>
                    <Typography gutterBottom>Dealer Name</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">
                        {appService.countries.getValueByKey(registration.dealerCountryCode)}
                    </Typography>
                    <Typography gutterBottom>Dealer Country</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h4">{registration.dealerAddress || '-'}</Typography>
                    <Typography gutterBottom>Address</Typography>
                </Grid>
            </Grid>
        </>
    )
}

export default Summary;